var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDoubleLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 5.29289C20.0976 5.68342 20.0976 6.31658 19.7071 6.70711L14.8142 11.6L19.7071 16.4929C20.0976 16.8834 20.0976 17.5166 19.7071 17.9071C19.3166 18.2976 18.6834 18.2976 18.2929 17.9071L12.6929 12.3071C12.5054 12.1196 12.4 11.8652 12.4 11.6C12.4 11.3348 12.5054 11.0804 12.6929 10.8929L18.2929 5.29289C18.6834 4.90237 19.3166 4.90237 19.7071 5.29289ZM11.3071 5.29289C11.6976 5.68342 11.6976 6.31658 11.3071 6.70711L6.41421 11.6L11.3071 16.4929C11.6976 16.8834 11.6976 17.5166 11.3071 17.9071C10.9166 18.2976 10.2834 18.2976 9.89289 17.9071L4.29289 12.3071C3.90237 11.9166 3.90237 11.2834 4.29289 10.8929L9.89289 5.29289C10.2834 4.90237 10.9166 4.90237 11.3071 5.29289Z",
    fill: "#101728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoubleLeft);
export default __webpack_public_path__ + "static/media/ic-double-left.7aeaebf25e7945804ea80111718b8d36.svg";
export { ForwardRef as ReactComponent };